import type { OrganizationBilling } from './billing';

const SUBSCRIBED_STATUSES = new Set(['trialing', 'active', 'past_due', 'unpaid']);

export const isLifetimeBilling = (billing: OrganizationBilling | null | undefined): boolean =>
    billing?.source === 'lifetime';

export const hasExistingBillingSubscription = (billing: OrganizationBilling | null | undefined): boolean => {
    if (!billing?.subscriptionStatus) {
        return false;
    }

    return SUBSCRIBED_STATUSES.has(billing.subscriptionStatus);
};
